import React, {useState} from "react";

import * as Yup from 'yup';

import Container from "../Container";
import {Formik, FormikHelpers} from "formik";
import {Field, Form, FormRow} from "../../designSystem/Form";
import {validateMandatory} from "../../utils/formUtils";
import {Button} from "../../designSystem/Button";
import {scrollToTop} from "../../utils/utils";

export interface InformationFormProps {
    titleNumber?: number;
    initialValues: InformationFormValues;
    setValues: (values: InformationFormValues) => void;
    setValidated: (b: boolean) => void;
    isValidated?: boolean;
}

export interface InformationFormValues {
    birthName?: string;
    birthCity: string;
    address: string;
    addressDetails?: string;
    zipCode: string;
    city: string;
    country: string;
    phone: string;
    email: string;
}

const InformationForm = (props: InformationFormProps) => {

    const [close, setClose] = useState<boolean>(false)
    const [validated, setValidated] = useState<boolean>(!!props.isValidated)

    const InformationFormSchema = Yup.object().shape({
        'zipCode': Yup.string().matches(RegExp('[+0-9 ]+'), "Le code postal n'est pas valide"),
        'phone': Yup.string().matches(RegExp('[+0-9 ]+'), 'Le format du numéro n\'est pas accepté'),
        'email': Yup.string().email('Le format de l\'email n\'est pas accepté')
    })

    return (
      <Container
        id={"InformationFormContainer"}
        containerTitle={"Informations Pratiquant"}
        titleNumber={props.titleNumber}
        close={close}
        setClose={() => setClose(!close)}
        validated={validated}
      >
        <Formik
          initialValues={props.initialValues}
          validationSchema={InformationFormSchema}
          onSubmit={(
            values: InformationFormValues,
            { setSubmitting }: FormikHelpers<InformationFormValues>
          ) => {
            setSubmitting(false);
            props.setValues({
                ...values,
                phone: values.phone.trim(),
            });
            setClose(true);
            setValidated(true);
            props.setValidated(true);
            scrollToTop("InformationFormContainer")();
          }}
        >
          <Form>
            <FormRow>
              <Field
                id={"birthName"}
                name={"birthName"}
                placeholder={"Ex : Dupont"}
                label={"Nom de naissance"}
                validate={validateMandatory}
              />
              <Field
                id={"birthCity"}
                name={"birthCity"}
                placeholder={"Ex : Marseille"}
                validate={validateMandatory}
                label={"Commune de naissance"}
                onChange={() => {setValidated(false)}}
              />
            </FormRow>
            <Field
              id={"address"}
              name={"address"}
              placeholder={"Ex : 12 rue de l'Eglise"}
              validate={validateMandatory}
              label={"Adresse"}
              onChange={() => {setValidated(false)}}
            />
            <Field
              id={"addressDetails"}
              name={"addressDetails"}
              label={"Complément d'adresse"}
              optional
              onChange={() => {setValidated(false)}}
            />
            <FormRow>
              <Field
                id={"zipCode"}
                name={"zipCode"}
                label={"Code postal"}
                placeholder={"Ex : 56100"}
                validate={validateMandatory}
                onChange={() => {setValidated(false)}}
                className={"min-w-24"}
              />
              <Field
                id={"city"}
                name={"city"}
                label={"Ville"}
                placeholder={"Ex : Lorient"}
                validate={validateMandatory}
                onChange={() => {setValidated(false)}}
                className={"flex-3"}
              />
            </FormRow>
            <FormRow>
              <Field
                id={"country"}
                name={"country"}
                label={"Pays"}
                validate={validateMandatory}
                onChange={() => {setValidated(false)}}
              />
              <Field
                id={"phone"}
                name={"phone"}
                label={"Télephone"}
                placeholder={"Ex : 06 12 34 56 78"}
                validate={validateMandatory}
                onChange={() => {setValidated(false)}}
              />
            </FormRow>
            <Field
              id={"email"}
              name={"email"}
              label={"Email"}
              placeholder={"Ex : charlotte.martin@gmail.com"}
              validate={validateMandatory}
              onChange={() => {setValidated(false)}}
            />
            <div className={"flex items-center justify-center md:justify-end"}>
              <Button disabled={validated} type="submit">
                Confirmer
              </Button>
            </div>
          </Form>
        </Formik>
      </Container>
    );
}

export default InformationForm;